import "./CSS_styles/footer3d.css";

export default function Footer3D() {
  return (
    <footer className="footer3d" data-section="footer">
      <span>© 2026 Ankith Rudra.&nbsp;&nbsp; All Rights Reserved.</span>
    </footer>
  );
}